import { render, staticRenderFns } from "./WireSettingsDialog.vue?vue&type=template&id=2c15e728&scoped=true"
import script from "./WireSettingsDialog.vue?vue&type=script&lang=js"
export * from "./WireSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./WireSettingsDialog.vue?vue&type=style&index=0&id=2c15e728&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c15e728",
  null
  
)

export default component.exports